import type { Topic } from "@/types/news";

export const topics: Topic[] = [
  {
    id: "xingye-ad-clip",
    title: "星野乳业秋季新品代言物料被指「换脸拼接」",
    tagline: "一段宣传片被逐帧比对，品牌方首轮回应未解释后期处理问题",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20overlapping%20portrait%20frames%20and%20glitch%20seams%20on%20cream%20paper%20texture%2C%20warm%20vermilion%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-01&orientation=landscape",
    category: "zhengyi",
    status: "tracking",
    heat: 9842,
    publishedAt: "2026-09-04 21:10",
    updatedAt: "2026-09-09 18:40",
    tags: ["品牌代言", "物料争议", "后期处理"],
    summary:
      "有网友将星野乳业秋季新品宣传片逐帧截图比对，发现其中人物面部轮廓与光线的衔接处存在不自然痕迹，提出「换脸拼接」质疑。品牌方首轮回应仅强调「物料合规」，未正面解释后期处理，争议随之升级。",
    overview: [
      "9 月 4 日晚，星野乳业发布秋季新品宣传片，时长约 40 秒，由代言人出镜介绍新品。发布后不久，有网友将画面放大并逐帧比对，指出人物下颌与颈部交界处的光影走向不连贯，且在快速转身的镜头中出现了边缘模糊。",
      "截至 9 月 9 日，品牌方共发布两次说明，均未直接回答「画面是否经过后期拼接处理」这一核心问题，只表示物料「符合内部审核流程」。争议由此从「画面问题」转向「回应是否坦诚」。",
    ],
    timeline: [
      { time: "09-04 21:10", title: "宣传片上线", desc: "星野乳业发布秋季新品 40 秒宣传片，代言人出镜。" },
      { time: "09-05 10:30", title: "网友逐帧比对", desc: "有网友发布对比图，指出面部光影衔接不自然，提出拼接质疑。" },
      { time: "09-06 15:00", title: "话题进入热搜前列", desc: "讨论量快速上升，衍生出多个剪辑对比视频。" },
      { time: "09-07 20:20", title: "品牌首轮回应", desc: "品牌方称物料「符合内部审核流程」，未回应后期处理问题。" },
      { time: "09-09 18:40", title: "二次说明发布", desc: "品牌方补充说明拍摄与制作分工，但仍未正面回应核心质疑。" },
    ],
    disputes: [
      { point: "画面是否存在拼接", detail: "质疑方认为光影与轮廓不连贯；品牌方未确认也未否认，只强调流程合规。" },
      { point: "回应是否避重就轻", detail: "大量讨论集中在「为什么不直接说清楚」，而非画面本身。" },
      { point: "代言人是否知情", detail: "目前没有任何一方公开说明代言人对物料制作的参与程度。" },
    ],
    sentiment: { support: 24, neutral: 33, doubt: 43 },
    responses: [
      { party: "星野乳业", content: "物料制作符合内部审核流程，相关画面经过常规色彩与剪辑处理。", time: "09-07 20:20" },
      { party: "星野乳业", content: "补充说明拍摄与后期由不同团队分工完成，具体处理细节不便对外展开。", time: "09-09 18:40" },
      { party: "代言人工作室", content: "暂未就物料制作细节作出回应。", time: "截至 09-09" },
    ],
    factChecks: [
      { claim: "宣传片中人物面部由另一段素材替换拼接而成", verdict: "unproven", detail: "目前仅有网友的逐帧对比推断，缺少制作方素材或专业鉴定结论支撑，暂无法确认。" },
      { claim: "品牌方已承认宣传片存在后期拼接", verdict: "false", detail: "品牌方两次说明均未提及「拼接」字样，该说法与公开声明不符。" },
    ],
    related: ["variety-edit-order", "live-price-gap", "design-collision"],
  },
  {
    id: "variety-edit-order",
    title: "云雀综艺《一起去远方》剪辑顺序引争议",
    tagline: "同一段对话被放在不同语境，观众认为影响了人物形象",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20film%20strip%20frames%20rearranged%20on%20cream%20paper%20texture%2C%20warm%20vermilion%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-02&orientation=landscape",
    category: "zhengyi",
    status: "tracking",
    heat: 8721,
    publishedAt: "2026-09-02 12:00",
    updatedAt: "2026-09-08 21:15",
    tags: ["综艺剪辑", "节目制作", "舆论争议"],
    summary:
      "观众发现云雀综艺《一起去远方》中，嘉宾的一段对话在不同期数中被剪进了两个完全不同的场景，导致人物态度看起来前后矛盾。节目组回应称属于「叙事需要」，未说明是否调整过时间顺序。",
    overview: [
      "从 8 月底开始，陆续有观众把《一起去远方》的片段拼接对比，指出同一句「那我们先别急」在第 5 期与第 7 期分别出现在不同情境下，导致观众对嘉宾的判断完全不同。",
      "节目组在 9 月 6 日作出说明，表示剪辑「服务于整体叙事节奏」。但有观众认为，说明回避了「是否打乱拍摄时间顺序」这一关键问题。",
    ],
    timeline: [
      { time: "08-28", title: "观众发现片段重复", desc: "有观众指出同一句台词出现在两处不同语境。" },
      { time: "09-02", title: "对比视频集中出现", desc: "多个剪辑对比视频被集中转发，话题进入讨论热区。" },
      { time: "09-06", title: "节目组回应", desc: "节目组称剪辑服务于叙事节奏，感谢观众关注。" },
      { time: "09-08", title: "讨论转向制作规范", desc: "争议焦点从具体片段转向综艺剪辑的行业惯例。" },
    ],
    disputes: [
      { point: "画面是否打乱时间顺序", detail: "观众以台词重复为据认为存在调序；节目组未明确回答。" },
      { point: "是否影响人物形象", detail: "双方对「调序是否构成误导」看法差异明显。" },
      { point: "行业惯例边界在哪", detail: "讨论扩散到综艺剪辑的通用做法与观众知情权。" },
    ],
    sentiment: { support: 31, neutral: 29, doubt: 40 },
    responses: [
      { party: "《一起去远方》节目组", content: "剪辑始终服务于整体叙事节奏，感谢观众的关注与讨论。", time: "09-06 14:00" },
      { party: "播出平台", content: "暂未就节目后期制作细节作出单独说明。", time: "截至 09-08" },
    ],
    factChecks: [
      { claim: "节目中嘉宾在同一场景重复说了完全相同的一句话", verdict: "partial", detail: "对比显示两句台词内容高度一致，但无法排除录制时确实有相似表达，属部分属实待确认。" },
      { claim: "节目组承认人为打乱了拍摄时间顺序", verdict: "false", detail: "节目组说明中未出现「调序」表述，该说法与公开回应不符。" },
    ],
    related: ["xingye-ad-clip", "trailer-spoiler", "topic-drift"],
  },
  {
    id: "ai-voice-check",
    title: "网传「AI 合成语音留言」事件核查",
    tagline: "一段声称由当事人本人录制的语音被广泛转发，核查显示合成痕迹明显",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20sound%20waveform%20and%20digital%20fragments%20on%20cream%20paper%20texture%2C%20muted%20olive%20green%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-03&orientation=landscape",
    category: "piyao",
    status: "settled",
    heat: 7640,
    publishedAt: "2026-08-26 09:40",
    updatedAt: "2026-09-01 16:20",
    tags: ["AI 合成", "语音核查", "不实信息"],
    summary:
      "一段约 30 秒的语音被指为某当事人「本人留言」并在多个群聊转发。核查发现，该语音在音素衔接与呼吸节奏上存在明显合成特征，当事人团队已明确否认录制过该内容，事件已澄清。",
    overview: [
      "8 月 26 日起，一段语音在社交平台流传，内容涉及对某争议的个人表态。传播者称其为当事人本人录制。",
      "经比对，该语音在多个音节交界处出现统一的轻微断裂，且全程缺少自然换气，符合常见语音合成工具的输出特征。当事人团队 8 月 30 日发布声明明确否认，9 月 1 日相关内容被平台标注。",
    ],
    timeline: [
      { time: "08-26", title: "语音开始流传", desc: "一段 30 秒语音在群聊与社交平台被转发。" },
      { time: "08-28", title: "出现技术质疑", desc: "有网友指出语音缺少自然换气与音素衔接异常。" },
      { time: "08-30", title: "当事人团队否认", desc: "团队声明从未录制该内容，保留追责权利。" },
      { time: "09-01", title: "平台标注提示", desc: "相关内容被标注为疑似合成，事件基本澄清。" },
    ],
    disputes: [
      { point: "语音是否由本人录制", detail: "当事人团队明确否认，技术比对也支持合成结论。" },
      { point: "首发来源是谁", detail: "目前无法确认最初上传者的身份与动机。" },
    ],
    sentiment: { support: 62, neutral: 26, doubt: 12 },
    responses: [
      { party: "当事人工作室", content: "从未录制或授权发布该语音，内容系伪造，已保留追究法律责任的权利。", time: "08-30" },
      { party: "相关平台", content: "已对相关音频添加「疑似合成内容」提示。", time: "09-01" },
    ],
    factChecks: [
      { claim: "该语音由当事人本人录制", verdict: "false", detail: "当事方明确否认，且语音存在合成特征，确认为不实。" },
      { claim: "语音来自某直播片段剪辑", verdict: "unproven", detail: "未找到对应的直播原片段，该说法缺乏依据。" },
    ],
    related: ["actor-quit-rumor", "charity-bill", "topic-drift"],
  },
  {
    id: "festival-refund",
    title: "灯火音乐节退票规则调整引发讨论",
    tagline: "主办方中途修改退票时间，已购票观众认为规则说改就改",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20concert%20stage%20lights%20and%20ticket%20shapes%20on%20cream%20paper%20texture%2C%20warm%20vermilion%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-04&orientation=landscape",
    category: "reyi",
    status: "tracking",
    heat: 8210,
    publishedAt: "2026-09-05 14:20",
    updatedAt: "2026-09-09 11:05",
    tags: ["音乐节", "退票规则", "消费者权益"],
    summary:
      "灯火音乐节在开票后第十天修改了退票截止时间，将原本的「演出前 7 天」缩短为「演出前 15 天」，部分已购票观众认为规则变更影响了自己的安排，主办方回应称系「配合场地要求」。",
    overview: [
      "9 月 5 日，主办方在购票页面更新了退票说明，将免费退票的截止时间提前。由于部分观众在旧规则下购票，规则变更后立即产生不满。",
      "主办方 9 月 7 日回应称调整是为配合场馆的入场安排，并开放了针对已购票观众的单独申请通道。截至 9 月 9 日，已有观众反馈申请仍在处理中。",
    ],
    timeline: [
      { time: "09-05 14:20", title: "退票规则更新", desc: "免费退票截止时间由演出前 7 天改为 15 天。" },
      { time: "09-06", title: "观众集中反馈", desc: "已购票观众在社交平台表达对规则变更的不满。" },
      { time: "09-07 19:30", title: "主办方回应", desc: "主办方表示为配合场馆安排，并开放单独申请通道。" },
      { time: "09-09 11:05", title: "处理进度更新", desc: "部分观众反馈申请仍在处理中，主办方称将加快。" },
    ],
    disputes: [
      { point: "规则能否中途修改", detail: "观众认为已购票应沿用旧规则；主办方称有权根据场地要求调整。" },
      { point: "补偿方案是否到位", detail: "单独通道是否覆盖所有受影响观众，目前仍在核实。" },
    ],
    sentiment: { support: 18, neutral: 30, doubt: 52 },
    responses: [
      { party: "灯火音乐节主办方", content: "调整系配合场馆入场安排，已为已购票观众开放单独退票申请通道。", time: "09-07 19:30" },
      { party: "场馆方", content: "未就入场安排细节单独作出说明。", time: "截至 09-09" },
    ],
    factChecks: [
      { claim: "主办方完全关闭了所有退票通道", verdict: "false", detail: "主办方仍开放单独申请通道，该说法与实际情况不符。" },
      { claim: "规则变更未作任何通知", verdict: "partial", detail: "购票页面有更新说明，但部分观众称未收到主动推送，属部分属实。" },
    ],
    related: ["live-price-gap", "topic-drift", "trailer-spoiler"],
  },
  {
    id: "live-price-gap",
    title: "直播带货「先涨后降」价格质疑",
    tagline: "观众对比历史页面截图，质疑直播间标价与日常售价不符",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20price%20tags%20and%20ascending%20bar%20charts%20on%20cream%20paper%20texture%2C%20warm%20vermilion%20and%20terracotta%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-05&orientation=landscape",
    category: "zhengyi",
    status: "tracking",
    heat: 9130,
    publishedAt: "2026-09-03 20:00",
    updatedAt: "2026-09-09 09:30",
    tags: ["直播带货", "价格争议", "消费者权益"],
    summary:
      "有观众用历史页面截图对比，指出某场直播中宣称的「到手价」与商品日常在售价格接近，怀疑存在先提价再打折。主播团队回应称价格由品牌方设定，品牌方暂未给出完整说明。",
    overview: [
      "9 月 3 日晚的直播中，一款日化产品被标注为「直播间专属价」。随后有观众晒出此前一段时间的商品页面截图，显示日常价格与直播价差距不大。",
      "主播团队 9 月 5 日回应称定价由品牌方提供，团队不参与设置。截至 9 月 9 日，品牌方仅回应「正在核对」，未公布完整价格记录。",
    ],
    timeline: [
      { time: "09-03 20:00", title: "直播进行中", desc: "产品以「直播间专属价」形式上架售卖。" },
      { time: "09-04", title: "比价截图出现", desc: "观众晒出历史页面截图，指价格差距有限。" },
      { time: "09-05 16:40", title: "主播团队回应", desc: "团队称定价由品牌方设定，自身不参与。" },
      { time: "09-09 09:30", title: "品牌方称正在核对", desc: "品牌方表示正在核对历史价格记录。" },
    ],
    disputes: [
      { point: "是否存在先涨后降", detail: "质疑方以截图对比为据；品牌方称需核对完整记录。" },
      { point: "定价责任归属", detail: "主播团队与品牌方对定价由谁决定说法不完全一致。" },
    ],
    sentiment: { support: 22, neutral: 27, doubt: 51 },
    responses: [
      { party: "主播团队", content: "商品定价由品牌方提供，我们只负责直播讲解与销售。", time: "09-05 16:40" },
      { party: "品牌方", content: "正在核对相关历史价格记录，将尽快给出说明。", time: "09-09 09:30" },
    ],
    factChecks: [
      { claim: "直播间商品价格高于日常售价", verdict: "unproven", detail: "现有比对基于零散截图，缺少完整价格记录，暂无法确认。" },
      { claim: "主播团队自行设定商品价格", verdict: "false", detail: "团队与品牌方均表示定价由品牌方提供，该说法与双方表述不符。" },
    ],
    related: ["xingye-ad-clip", "festival-refund", "design-collision"],
  },
  {
    id: "actor-quit-rumor",
    title: "网传「演员宣布退圈」传闻核查",
    tagline: "一则截图被当作正式声明传播，核查未找到任何官方出处",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20a%20torn%20document%20and%20magnifying%20glass%20on%20cream%20paper%20texture%2C%20muted%20olive%20green%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-06&orientation=landscape",
    category: "piyao",
    status: "settled",
    heat: 6980,
    publishedAt: "2026-08-18 11:20",
    updatedAt: "2026-08-24 10:00",
    tags: ["不实传闻", "截图核查", "明星动态"],
    summary:
      "一张标注为「工作室声明」的截图在多个平台传播，内容为宣布演员将退出演艺工作。核查发现该截图排版与官方账号历史声明差异明显，工作室已于 8 月 21 日发布正式声明否认，事件澄清。",
    overview: [
      "8 月 18 日，一张声明截图开始传播。截图未附链接，也无任何官方账号发布记录。",
      "比对发现，截图字体与工作室既往声明模板不一致，落款日期格式也不同。工作室于 8 月 21 日通过官方账号明确否认，并提示网友注意辨别信息来源。",
    ],
    timeline: [
      { time: "08-18", title: "截图开始传播", desc: "一张所谓的退圈声明截图在多平台流传。" },
      { time: "08-19", title: "被指排版异常", desc: "有网友指出字体与落款格式与官方模板不符。" },
      { time: "08-21", title: "工作室否认", desc: "官方账号发布声明，称截图内容为伪造。" },
      { time: "08-24", title: "传播逐步平息", desc: "相关话题热度回落，事件基本澄清。" },
    ],
    disputes: [
      { point: "截图是否为官方发布", detail: "官方否认，且无任何账号发布记录可查。" },
      { point: "图片来源是谁", detail: "目前无法确定首发者身份。" },
    ],
    sentiment: { support: 66, neutral: 24, doubt: 10 },
    responses: [
      { party: "演员工作室", content: "网传声明截图系伪造，本人工作安排正常，请以官方账号发布为准。", time: "08-21" },
    ],
    factChecks: [
      { claim: "该演员已宣布退出演艺工作", verdict: "false", detail: "工作室明确否认，无官方发布记录，确认为不实。" },
      { claim: "截图来自某媒体报道", verdict: "unproven", detail: "未找到任何媒体发布该内容的记录。" },
    ],
    related: ["ai-voice-check", "charity-bill", "drama-rank-doubt"],
  },
  {
    id: "drama-rank-doubt",
    title: "年度剧集口碑榜单数据遭质疑",
    tagline: "同一批剧集在两个榜单名次差异明显，评分统计口径成为争议点",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20ranking%20bars%20and%20star%20rating%20symbols%20on%20cream%20paper%20texture%2C%20warm%20terracotta%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-07&orientation=landscape",
    category: "guancha",
    status: "verifying",
    heat: 6430,
    publishedAt: "2026-08-29 15:00",
    updatedAt: "2026-09-07 17:45",
    tags: ["榜单数据", "统计口径", "舆论观察"],
    summary:
      "有网友对比两个年度剧集榜单，发现同一部剧在评分人数接近的情况下名次相差十余位。榜单方回应称统计周期与去重规则不同，但未公开完整计算方式，讨论仍在继续。",
    overview: [
      "8 月底，网友将两个平台的年度剧集榜单并列比较，发现部分剧集名次差异明显。",
      "榜单制作方表示，两个榜单的统计周期、去重策略与权重设定不同，因此结果不应直接比较。由于完整计算过程未公开，部分观众仍持保留态度。",
    ],
    timeline: [
      { time: "08-29", title: "榜单对比帖出现", desc: "网友并列两个榜单，指出名次差异。" },
      { time: "09-01", title: "榜单方首次回应", desc: "回应称两个榜单统计口径不同，不宜直接比较。" },
      { time: "09-07", title: "讨论扩展到统计透明度", desc: "话题转向榜单评分是否应公开计算方法。" },
    ],
    disputes: [
      { point: "名次差异是否合理", detail: "榜单方称口径不同；质疑方认为差异幅度难以用口径解释。" },
      { point: "计算方式是否应公开", detail: "讨论集中在榜单公信力与透明度。" },
    ],
    sentiment: { support: 29, neutral: 41, doubt: 30 },
    responses: [
      { party: "榜单制作方", content: "两个榜单在统计周期、去重规则与权重上均不相同，结果不具直接可比性。", time: "09-01" },
    ],
    factChecks: [
      { claim: "榜单存在人为刷分", verdict: "unproven", detail: "暂无证据指向人为干预，现有讨论主要围绕统计口径差异。" },
      { claim: "两个榜单使用完全相同的评分数据", verdict: "false", detail: "榜单方明确表示统计周期与去重规则不同，两榜数据来源并不完全一致。" },
    ],
    related: ["topic-drift", "actor-quit-rumor", "variety-edit-order"],
  },
  {
    id: "trailer-spoiler",
    title: "电影《长夜行者》预告片剧透风波",
    tagline: "新预告被指包含关键情节，导演回应称「预告本身就是作品的一部分」",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20cinema%20curtain%20and%20film%20frames%20on%20cream%20paper%20texture%2C%20warm%20vermilion%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-08&orientation=landscape",
    category: "reyi",
    status: "tracking",
    heat: 7120,
    publishedAt: "2026-09-06 18:30",
    updatedAt: "2026-09-09 20:10",
    tags: ["电影宣发", "预告片", "剧透争议"],
    summary:
      "电影《长夜行者》发布第二支预告后，有观众认为其中出现了接近结局的关键画面，担心影响观影体验。导演在采访中回应称预告经过剪辑设计，不会破坏观影感受，讨论仍在持续。",
    overview: [
      "第二支预告于 9 月 6 日上线，时长约 1 分 40 秒。有观众指出其中一段场景的台词顺序与剧情走向高度相关。",
      "导演在 9 月 8 日的采访中表示，预告画面经过重新编排，与成片的呈现顺序并不完全一致。部分观众认可这一解释，也有观众希望在预告上增加剧透提示。",
    ],
    timeline: [
      { time: "09-06 18:30", title: "第二支预告上线", desc: "时长 1 分 40 秒，包含多段新画面。" },
      { time: "09-07", title: "剧透讨论出现", desc: "有观众认为部分画面接近关键情节。" },
      { time: "09-08 21:00", title: "导演回应", desc: "导演称预告经过独立剪辑设计，不影响观影体验。" },
      { time: "09-09 20:10", title: "讨论转向宣发提示", desc: "观众希望片方在预告前增加剧透提醒。" },
    ],
    disputes: [
      { point: "预告是否泄露关键情节", detail: "导演称顺序被重新编排；部分观众仍认为信息量偏大。" },
      { point: "预告是否应加提示", detail: "讨论集中在宣发物料的信息边界。" },
    ],
    sentiment: { support: 40, neutral: 34, doubt: 26 },
    responses: [
      { party: "导演本人", content: "预告是独立剪辑的，画面顺序和成片不同，不会影响观影感受。", time: "09-08 21:00" },
      { party: "发行方", content: "已收到观众关于剧透提示的建议，正在内部讨论。", time: "09-09" },
    ],
    factChecks: [
      { claim: "预告片使用了电影的结局画面", verdict: "unproven", detail: "导演称画面顺序经重新编排，缺乏成片比对依据，暂无法确认。" },
      { claim: "片方已公开承认预告存在剧透", verdict: "false", detail: "片方仅表示会讨论提示建议，未承认剧透。" },
    ],
    related: ["variety-edit-order", "festival-refund", "xingye-ad-clip"],
  },
  {
    id: "charity-bill",
    title: "公益项目费用明细质疑与回应",
    tagline: "捐赠者对执行费用占比提出疑问，项目方公开部分材料等待核对",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20receipt%20pages%20and%20a%20heart%20symbol%20on%20cream%20paper%20texture%2C%20muted%20olive%20green%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-09&orientation=landscape",
    category: "piyao",
    status: "verifying",
    heat: 5870,
    publishedAt: "2026-08-22 10:10",
    updatedAt: "2026-09-05 14:00",
    tags: ["公益透明", "费用明细", "材料核对"],
    summary:
      "有捐赠者对某公益项目的执行费用占比提出疑问，并通过公开渠道要求说明。项目方随后公开了部分执行材料，表示其余明细正在整理，核查仍在进行中。",
    overview: [
      "8 月 22 日，有捐赠者发布对项目费用结构的疑问，指出执行费用在总支出中的占比高于预期。",
      "项目方 8 月 27 日回应，说明费用包含物资运输与现场执行，并公开了部分票据。由于完整明细仍在整理，事件目前处于材料核对阶段。",
    ],
    timeline: [
      { time: "08-22", title: "捐赠者提出疑问", desc: "对项目执行费用占比提出质疑并要求说明。" },
      { time: "08-27", title: "项目方首次回应", desc: "说明费用构成，公开部分票据材料。" },
      { time: "09-05", title: "材料仍在整理", desc: "项目方表示完整明细正在整理，将陆续公布。" },
    ],
    disputes: [
      { point: "执行费用占比是否合理", detail: "双方对合理区间的判断不同，尚缺完整数据支撑。" },
      { point: "明细公布是否完整", detail: "目前仅公开部分票据，核查仍在进行。" },
    ],
    sentiment: { support: 45, neutral: 38, doubt: 17 },
    responses: [
      { party: "公益项目方", content: "费用包含物资运输与现场执行成本，部分票据已公开，完整明细正在整理。", time: "08-27" },
    ],
    factChecks: [
      { claim: "项目资金被挪作他用", verdict: "unproven", detail: "目前没有证据支持资金挪用，项目方已公开部分票据，核查仍在进行。" },
      { claim: "项目方拒绝公开任何材料", verdict: "false", detail: "项目方已公开部分票据，该说法不准确。" },
    ],
    related: ["ai-voice-check", "actor-quit-rumor", "drama-rank-doubt"],
  },
  {
    id: "design-collision",
    title: "新品发布会「设计撞车」争议",
    tagline: "两款外观相近的周边几乎同期发布，双方就创作时间线各执一词",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20two%20similar%20geometric%20objects%20side%20by%20side%20on%20cream%20paper%20texture%2C%20warm%20vermilion%20and%20terracotta%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-10&orientation=landscape",
    category: "zhengyi",
    status: "tracking",
    heat: 6780,
    publishedAt: "2026-09-01 16:00",
    updatedAt: "2026-09-08 12:20",
    tags: ["设计争议", "原创认定", "发布时间线"],
    summary:
      "两个品牌几乎同期发布外观高度相似的新品周边，双方均表示设计为独立完成。由于都未公开完整创作过程，争议目前停留在时间线比对阶段。",
    overview: [
      "9 月 1 日，两家品牌先后发布新品周边，外观元素被网友指出高度相似。",
      "双方在 9 月 3 日至 9 月 6 日间分别回应，均强调设计独立完成并给出大致立项时间，但都未公开设计草图或过程记录。",
    ],
    timeline: [
      { time: "09-01 16:00", title: "两品牌先后发布", desc: "新品周边发布时间相差不足 24 小时。" },
      { time: "09-02", title: "相似度引发讨论", desc: "网友并列对比，指出外观元素接近。" },
      { time: "09-03", title: "甲品牌回应", desc: "称设计独立完成并给出立项时间。" },
      { time: "09-06", title: "乙品牌回应", desc: "同样强调独立创作，双方时间线存在重叠。" },
    ],
    disputes: [
      { point: "设计是否独立完成", detail: "双方均称独立创作，但未公开过程材料。" },
      { point: "立项时间谁更早", detail: "双方给出的时间线存在重叠，难以据此判断。" },
    ],
    sentiment: { support: 33, neutral: 42, doubt: 25 },
    responses: [
      { party: "甲品牌", content: "该系列设计于今年年初立项，为团队独立完成。", time: "09-03" },
      { party: "乙品牌", content: "我方设计同样为内部原创，立项时间早于公开发布数月。", time: "09-06" },
    ],
    factChecks: [
      { claim: "其中一方抄袭了另一方的设计", verdict: "unproven", detail: "双方均否认抄袭，且未公开可对比的设计过程材料，暂无法认定。" },
      { claim: "两品牌使用同一家设计外包公司", verdict: "false", detail: "双方公布的合作方信息不同，该说法缺乏依据。" },
    ],
    related: ["xingye-ad-clip", "live-price-gap", "drama-rank-doubt"],
  },
  {
    id: "topic-drift",
    title: "「话题被带偏」传播路径观察：一次讨论是怎么跑题的",
    tagline: "从原始诉求到无关争吵，拆解一个话题在 48 小时内的三次转向",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20diverging%20arrows%20and%20network%20nodes%20on%20cream%20paper%20texture%2C%20warm%20terracotta%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=1200&height=800&seq=kb-topic-11&orientation=landscape",
    category: "guancha",
    status: "settled",
    heat: 5210,
    publishedAt: "2026-08-15 09:00",
    updatedAt: "2026-08-20 18:00",
    tags: ["传播观察", "话题偏移", "信息甄别"],
    summary:
      "一个原本关于服务质量的讨论，在 48 小时内经历了三次话题转向，最终焦点变成了与原始诉求无关的争吵。我们按时间还原了这次偏移的路径。",
    overview: [
      "最初，一位用户提出的是服务流程问题，诉求具体、指向明确。",
      "随着转发量上升，讨论陆续转向对当事人身份、用词和过往言论的评价，原始诉求被逐渐淹没。到第三天，话题核心已与最初的问题关系不大。",
    ],
    timeline: [
      { time: "08-15 09:00", title: "原始诉求提出", desc: "用户提出具体的服务流程问题，诉求明确。" },
      { time: "08-15 18:00", title: "第一次转向", desc: "讨论开始聚焦当事人的表达方式。" },
      { time: "08-16", title: "第二次转向", desc: "话题扩展到对当事人过往言论的评价。" },
      { time: "08-17", title: "第三次转向", desc: "讨论演变为群体间争吵，原始诉求基本消失。" },
    ],
    disputes: [
      { point: "原始诉求是否被回应", detail: "服务方始终未就最初的问题给出说明。" },
      { point: "话题为何偏移", detail: "高传播的片段多为情绪化内容，具体诉求被稀释。" },
    ],
    sentiment: { support: 38, neutral: 40, doubt: 22 },
    responses: [
      { party: "服务方", content: "未就最初的流程问题作出公开说明。", time: "截至 08-20" },
    ],
    factChecks: [
      { claim: "原始诉求是编造的", verdict: "unproven", detail: "无证据表明诉求为编造，但服务方也未公开回应，暂时无法核实。" },
      { claim: "话题中没有出现任何有效信息", verdict: "false", detail: "期间仍有用户整理时间线并指出偏移，并非完全没有有效信息。" },
    ],
    related: ["drama-rank-doubt", "variety-edit-order", "festival-refund"],
  },
];

export const getTopicById = (id: string): Topic | undefined =>
  topics.find((item) => item.id === id);

export const getTopicsByCategory = (slug: string): Topic[] =>
  topics.filter((item) => item.category === slug);